module.exports = __webpack_public_path__ + "img/6600.9525c709.jpg";